import { Grid, Group, Layout, Page } from "@/comn/components";
import { Checkbox } from "@/comn/components/_";
import { useFetch, useGrid, useModal, usePage, usePopup, useToast } from "@/comn/hooks";
import { comnEnvs } from "@/comn/utils";
import {
    APIS,
    SG_BLTBRD_TP_CD_LIST,
    SG_BTBDMS_TP_CD_VAL_LIST,
} from "@/tz/go/egaz/osci/ptl/sysm/bltbrd/services/OscibltbrdService";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

/*
 * Common Code Valid Value Details
 * !== 공통 코드 유효 값 상세 ==!
 */
export const OSCI0111016Q = (props: any) => {
    const { params, callback } = props; // Parameters received from the parent screen !== 부모화면으로 부터 받은 parameter ==!
    // const {pgeUid, menuId} = usePage();
    const { t } = useTranslation();
    const toast = useToast();
    const { close, postMessage, getParams } = usePopup();
    const [tpCdValList, setTpCdValList] = useState<tpCdValList>(); // TypeCode Value List State !== TypeCode Value List State ==!

    // Bulletin board Type Code Interface !== 게시판유형코드 ==!
    interface tpCd {
        btbdmsTpCd: string;
        btbdmsTpCdKoNm: string;
        btbdmsTpCdEnNm: string;
        btbdmsTpCdTzNm: string;
    }

    interface tpCdValList {
        content: tpCd[];
        __t: any;
    }

    const grid = {
        tpCdList: useGrid({
            defaultSchema: SG_BLTBRD_TP_CD_LIST,
        }),
        tpCdValList: useGrid({
            defaultSchema: SG_BTBDMS_TP_CD_VAL_LIST,
        }),
    };

    const fetch = {
        // View Bulletin board Type Code List information  !== 게시판 유형코드 목록 조회 ==!
        getTypeCodeList: useFetch({
            api: () => APIS.getTypeCodeList(),
            enabled: false,
            onSuccess: () => {},
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const handler = {
        // Check Type code List !== 유형코드 목록 조회 ==!
        getTypeCodeList: () => {
            fetch.getTypeCodeList.fetch();
        },

        // Click the a-tag in the parent grid !== 부모 그리드 내 a태그 클릭 ==!
        parentGridClick: (rowValues: any) => {
            setTpCdValList({
                content: rowValues.btbdmsTpCdValByLangList,
                __t: new Date(),
            });
        },

        // Click the Apply button (Apply Parent Screen) !== 적용 버튼 클릭 (부모화면에 적용) ==!
        clickApplyBtn: () => {
            callback({ tpCdList: grid.tpCdList.getChecked() });
        },

        // Check parent screen existing selection!== 부모화면 기존선택값 체크 ==!
        chkParentVal: () => {
            console.log(params);
            console.log(grid.tpCdList.getChecked());
            // grid.tpCdList.setSchema
            // const extractedKeys: any[] = [];

            // grid.tpCdList.grid._grid.current._content.forEach((item : any) => {
            //     const currentBtbdmsTpCd = item.btbdmsTpCd;

            //     const matchedParam = params.find((param : any) => param.btbdmsTpCd === currentBtbdmsTpCd);
            //     if (matchedParam) {
            //         extractedKeys.push(item.__key);
            //     }
            // });
            // console.log(extractedKeys);
            // grid.tpCdList.grid._grid.current._checked = extractedKeys;
            // console.log(grid.tpCdList.getChecked());
            // console.log(grid.tpCdList.grid._grid.current._content);
            // console.log(grid.tpCdList.grid._grid.current._checked);
            // params.map((obj: any) => {
            //     console.log(obj);
            // })
        },
    };

    const render = {
        cell: {
            btbdmsTpCd: (props: any) => {
                const { rowValues, value } = props;
                return <a onClick={handler.parentGridClick.bind(null, rowValues)}>{value}</a>;
            },
        },
    };

    useEffect(() => {
        handler.getTypeCodeList();
        handler.chkParentVal();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left size={8}>
                            <Group.Title title={t("T_BTBDMS_TP_CD_LST")} />
                            <Grid
                                {...grid.tpCdList.grid}
                                data={fetch.getTypeCodeList.data?.bltbrdTpCdList}
                                render={render}
                            />
                        </Layout.Left>
                        <Layout.Right size={4}>
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={t("T_BTBDMS_TP_CD_VAL_LST")} />
                                </Layout.Left>
                            </Layout>
                            <Grid {...grid.tpCdValList.grid} data={tpCdValList} />
                        </Layout.Right>
                    </Layout>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button role={"apply"} onClick={handler.clickApplyBtn} />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
